import React from 'react';
import { useMobile } from '../../hooks/useMobile';
import { Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import MyAppBar from '../AppBar/MyAppBar';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme: any) => ({
  root: ({ mobile }: any) => {
    return !mobile
      ? {
          height: '100vh',
          backgroundImage: `url(${theme.backgroundImage})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'right',
          position: 'absolute',
          backgroundColor: theme.palette.brand.cream,
        }
      : {};
  },
  titleText: {
    color: 'black',
    fontSize: 'xx-large',
    fontWeight: 'bold',
  },
}));

export default function Layout({ title, children, className = '' }) {
  const mobile = useMobile();
  const classes = useStyles({ mobile });
  const pagesToShowTopBanner = [
    '/login',
    '/signup',
    '/forgot-password',
    '/reset-password',
  ];

  return (
    <Grid container className={classes.root}>
      {pagesToShowTopBanner.includes(window.location.pathname) && <MyAppBar />}
      <Grid
        item
        sm={mobile ? 12 : 6}
        container
        alignItems="center"
        justifyContent="center"
        direction="column"
      >
        <Typography
          variant="h5"
          className={`${classes.titleText} ${className}`}
        >
          {title}
        </Typography>
        {children}
      </Grid>
    </Grid>
  );
}
